import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { LocalStorageService } from 'src/app/service/local-storage.service';
import { SessionStorageService } from 'src/app/service/session-storage.service';

@Component({
  selector: 'app-home-landing',
  templateUrl: './home-landing.component.html',
  styleUrls: ['./home-landing.component.scss'],
  standalone: false
})
export class HomeLandingComponent implements OnInit {

  constructor(
    private router: Router,
    private lStorageService: LocalStorageService,
    private sStorageService: SessionStorageService,
    private homeService: HomeService,
    private spinner: SpinnerService
  ) { }

  prelanding_url = ROUTES.PRE_LANDING.path;
  event_url = ROUTES.EVENT_LIST.path;
  home_url = ROUTES.HOME.path;
  spa_flux = 'spa';
  tender_flux = 'tender';

  ngOnInit(): void {
    this.sStorageService.clearStorage();
    this.homeService.clearSubject();
    this.spinner.hide();
  }

  goToSpaHome() {
    this.router.navigate([this.spa_flux+'/'+this.home_url]);
  }

  goToTenderHome() {
    this.router.navigate([this.tender_flux+'/'+this.home_url]);
  }

}
